import Cookies from 'js-cookie';

const secure = window.location.protocol === 'https:';

const Storage = {
    saveItem(key: string, value: string): string | null {
        try {
            return Cookies.set(key, value, { secure });
        } catch (error) {
            console.error('AsyncStorage Error', error);

            return null;
        }
    },
    load(key: string): string | null {
        try {
            return Cookies.get(key);
        } catch (error) {
            console.error(error);

            return null;
        }
    },
    delete(key: string): boolean {
        try {
            Cookies.remove(key);

            return true;
        } catch (error) {
            console.error(error);

            return false;
        }
    },
};

export function saveCRMCredentials(accessToken: string, refreshToken: string, tokenType: string, expiresIn: string) {
    Storage.saveItem('access_token', accessToken);
    Storage.saveItem('refresh_token', refreshToken);
    Storage.saveItem('token_type', tokenType);
    Storage.saveItem('expires_in', expiresIn);
}

export function deleteCRMCredentials() {
    ['access_token', 'refresh_token', 'token_type', 'expires_in'].forEach((key) => Storage.delete(key));
}

export default Storage;
